export default [
  {
    component: () => import("@/components/produtividade/MenuProdutividade.vue"),
    name: "produtividade",
    path: "/produtividade",
    label: "Produtividade",
  },
  {
    component: () => import("@/components/produtividade/SubmenuProdutividadeRelatorios.vue"),
    name: "produtividade.relatorios",
    path: "/produtividade/relatorios",
    label: "Relatórios",
  },
  {
    component: () => import("@/components/produtividade/relatorios/ViewProdutividadeRelatoriosEquipe.vue"),
    name: "produtividade.relatorios.equipe",
    path: "/produtividade/relatorios/equipe",
    label: "Visualizar Relatório de Equipe",
  },
  {
    component: () => import("@/components/produtividade/relatorios/ViewProdutividadeRelatoriosEquipeFuncionario.vue"),
    name: "produtividade.relatorios.equipe.funcionario",
    path: "/produtividade/relatorios/equipe/:id",
    label: "Visualizar Detalhamento por Representante",
  },
  {
    component: () => import("@/components/produtividade/relatorios/ViewProdutividadeRelatoriosPersonalizados.vue"),
    name: "produtividade.relatorios.personalizados",
    path: "/produtividade/relatorios/personalizados",
    label: "Meus Relatórios",
  },
  {
    component: () => import("@/components/comum/ticket/tickets-list.vue"),
    name: "produtividade.tickets",
    path: "/produtividade/tickets",
    label: "Tickets",
  },
  {
    component: () => import("@/components/comum/ticket/ticket-discussion.vue"),
    name: "produtividade.tickets.discussion",
    label: "Visualizar Discussão de Tickets",
    path: "/produtividade/tickets/discussion/:id",
  },
  {
    component: () => import("@/components/comum/ticket/ticket-form.vue"),
    name: "produtividade.tickets.novo",
    label: "Criar Novos Tickets",
    path: "/produtividade/tickets/create",
  },
  {
    component: () => import("@/components/comum/ticket/ticket-form.vue"),
    name: "produtividade.tickets.editar",
    label: "Editar Tickets",
    path: "/produtividade/tickets/edit/:id",
  },
  {
    component: () => import("@/components/comum/ticket/tickets-kanban.vue"),
    name: "produtividade.kanban",
    path: "/produtividade/kanban",
    label: "Kanban",
  },
  {
    component: () => import("@/components/produtividade/gantt/ViewProdutividadeGanttProjetos.vue"),
    name: "produtividade.gantt",
    path: "/produtividade/gantt",
    label: "Gantt",
  },
  {
    component: () => import("@/components/produtividade/gantt/ViewProdutividadeGantt.vue"),
    name: "produtividade.gantt.projeto",
    path: "/produtividade/gantt/projeto/:id",
    label: "Visualizar Gantt do Projeto",
  },
  {
    component: () => import("@/components/agenda/ViewProdutividadeAgenda.vue"),
    name: "produtividade.agenda",
    path: "/produtividade/agenda",
    label: "Agenda",
  },
  // Controle de Utilidades
  {
    component: () => import("@/components/almoxarifado/MenuAlmoxarifado.vue"),
    name: "produtividade.controle-de-utilidades",
    path: "/produtividade/controle-de-utilidades",
    label: "Controle de Utilidades",
  },
  {
    component: () => import("@/components/almoxarifado/MenuProdutosAlmoxarifado.vue"),
    name: "produtividade.controle-de-utilidades.produtos",
    path: "/produtividade/controle-de-utilidades/produtos",
    label: "Produtos",
  },
  {
    component: () => import("@/components/almoxarifado/GerenciarProdutosAlmoxarifado.vue"),
    name: "produtividade.controle-de-utilidades.produtos.gerenciar",
    path: "/produtividade/controle-de-utilidades/produtos/gerenciar",
    label: "Visualizar Lista de Produtos",
  },
  {
    component: () => import("@/components/almoxarifado/CadastroProdutoAlmoxarifado.vue"),
    name: "produtividade.controle-de-utilidades.produtos.novo",
    path: "/produtividade/controle-de-utilidades/produtos/novo",
    label: "Cadastrar Produto",
  },
  {
    component: () => import("@/components/almoxarifado/CadastroProdutoAlmoxarifado.vue"),
    name: "produtividade.controle-de-utilidades.produtos.editar",
    label: "Editar Produtos",
    path: "/produtividade/controle-de-utilidades/produtos/edit/:id",
  },
  {
    component: () => import("@/components/almoxarifado/GerenciarTiposAlmoxarifado.vue"),
    name: "produtividade.controle-de-utilidades.tipos.gerenciar",
    label: "Gerenciar Tipos",
    path: "/produtividade/controle-de-utilidades/tipos/gerenciar",
  },
  {
    component: () => import("@/components/almoxarifado/MenuMovimentacoesAlmoxarifado.vue"),
    name: "produtividade.controle-de-utilidades.movimentacoes",
    path: "/produtividade/controle-de-utilidades/movimentacoes",
    label: "Movimentações",
  },
  {
    component: () => import("@/components/almoxarifado/GerenciarMovimentacoesAlmoxarifado.vue"),
    name: "produtividade.controle-de-utilidades.movimentacoes.gerenciar",
    path: "/produtividade/controle-de-utilidades/movimentacoes/gerenciar",
    label: "Visualizar Lista de Movimentações",
  },
  {
    component: () => import("@/components/almoxarifado/CadastroMovimentacaoAlmoxarifado.vue"),
    name: "produtividade.controle-de-utilidades.movimentacoes.novo",
    path: "/produtividade/controle-de-utilidades/movimentacoes/novo",
    label: "Cadastrar Movimentações",
  },
  {
    component: () => import("@/components/almoxarifado/VisualizarMovimentacaoAlmoxarifado.vue"),
    name: "produtividade.controle-de-utilidades.movimentacoes.visualizar",
    label: "Visualizar Detalhes de Movimentações",
    path: "/produtividade/controle-de-utilidades/movimentacoes/visualizar/:id",
  },
  {
    component: () => import("@/components/almoxarifado/CadastroMovimentacaoAlmoxarifado.vue"),
    name: "produtividade.controle-de-utilidades.movimentacoes.editar",
    label: "Editar Movimentações",
    path: "/produtividade/controle-de-utilidades/movimentacoes/edit/:id",
  },
  {
    component: () => import("@/components/almoxarifado/HistoricoProdutosAlmoxarifado.vue"),
    name: "produtividade.controle-de-utilidades.movimentacoes.historico",
    label: "Visualizar Histórico de Movimentações",
    path: "/produtividade/controle-de-utilidades/movimentacoes/historico/:id",
  },
];
